import { requestSchema, memberReportSchema, hotelSchema } from 'store/schemas/database.schemas';
import { normalize } from 'normalizr';
import { actionCreators as memberReportsActionCreators } from 'store/actions/metaDatabase.memberReports.actions';
import { putDatabase } from 'store/actions/database.actions';
import RequestsRepository from '../../services/repositories/RequestsRepository';
import { actionCreators } from '../actions/metaDatabase.requests.actions';
import {
    saveEntity, buildRepositoryAction, loadEntityWithQueue, loadAll,
} from './helpers';
import { buildMetaRequestSelector } from '../selectors/requests.selector';
import { buildMetaReportsSelector } from '../selectors/memberReports.selector';

export const requestDetailsIncludes = [
    'user',
    'user.userEmails',
    'user.conciergeGroups.concierges.emails',
    'member',
    'member.travelAgency',
    'branding',
    'requestTypeHotel.destination.destinationDocuments',
    'requestHotels.hotel.destination.destinationDocuments',
    'requestQuotes.requestQuoteComponents',
    'requestQuotes.requestQuoteBundles.requestQuoteBundleComponents.requestQuoteComponent.requestComponent',
    'requestQuotes.requestQuoteComponents.requestComponent',
    'requestQuotes.requestQuoteComponents.requestComponent.currency',
    'requestQuotes.requestQuoteComponents.requestComponent.hotel.defaultServices',
    'requestQuotes.requestQuoteComponents.requestComponent.requestHotelRooms.requestHotelRoomPictures',
    'requestQuotes.requestQuoteComponents.requestComponent.requestHotelRooms.hotelRoom.hotelRoomPictures',
    'requestQuotes.requestQuoteComponents.requestComponent.requestHotelRooms',
    'requestQuotes.requestQuoteComponents.requestComponent.requestHotelRooms.promotion',
    'requestQuotes.requestQuoteComponents.requestComponent.requestHotelRooms.hotelPromotion',
    'requestQuotes.requestQuoteComponents.requestComponent.requestHotelRooms.currency',
    'requestQuotes.requestQuoteComponents.requestComponent.requestFlightLegs',
    'requestQuotes.requestQuoteComponents.requestComponent.requestFlightLegs.airline',
    'requestQuotes.requestQuoteComponents.requestComponent.requestFlightLegs.departureFromAirport',
    'requestQuotes.requestQuoteComponents.requestComponent.requestFlightLegs.departureToAirport',
    'requestQuotes.requestQuoteComponents.requestComponent.vendorService',
    'requestQuotes.requestQuoteComponents.requestComponent.vendorService.vendor',
    'requestQuotes.requestQuoteComponents.requestComponent.insurance',
    'requestDocuments',
];

export const requestTableIncludes = [
    'user',
    'requestQuotes.requestQuoteComponents.requestComponent.hotel.destination',
    'requestQuotes.requestQuoteComponents',
    'requestDates',
];

export const requestHeaderIncludes = [
    'user',
    'user.userEmails',
    'user.conciergeGroups.concierges.emails',
    'member',
    'member.travelAgency',
    'branding',
];

export function loadRequest(id, includes = null)
{
    return async (dispatch) =>
    {
        const result = await dispatch(loadEntityWithQueue(id, includes ?? requestDetailsIncludes, buildMetaRequestSelector, actionCreators, new RequestsRepository(), requestSchema));
        if (result?.isSuccess())
        {
            const hotels = result.response.requestQuotes?.map((requestQuote) =>
            {
                const requestQuoteHotel = requestQuote?.requestQuoteComponents?.filter((requestQuoteComponent) => requestQuoteComponent.component_type === 'Hotel') ?? [];
                return requestQuoteHotel.map((requestQuoteHotelComponent) => requestQuoteHotelComponent.requestComponent.hotel);
            });

            const n = normalize(hotels.flat(), [hotelSchema]);
            dispatch(putDatabase(n.entities));
        }

        return result;
    };
}

export function loadRequests(query, includes = null)
{
    return loadAll(query, includes ?? requestTableIncludes, buildMetaRequestSelector, actionCreators, new RequestsRepository(), requestSchema);
}

export function loadOpenQuotes()
{
    return async (dispatch, getState) =>
    {
        const reportId = 'open_quotes';
        const metaReportsSelector = buildMetaReportsSelector();
        const metaEntity = metaReportsSelector(getState(), reportId);

        if (metaEntity.loading) return;
        dispatch(memberReportsActionCreators._loading(reportId, true, []));

        const result = await (new RequestsRepository()).getOpenQuotes();
        dispatch(memberReportsActionCreators._loading(reportId, false, []));

        if (!result.isSuccess())
        {
            dispatch(memberReportsActionCreators._error(reportId, result.mergeMessages()));
            return;
        }

        const report = { id: reportId, requests: result.response };
        const schemaResult = normalize(report, memberReportSchema);

        dispatch(putDatabase(schemaResult.entities));
    };
}

export function saveRequest(data)
{
    return saveEntity(data.id, actionCreators, buildRepositoryAction(new RequestsRepository(), 'save', [data]), requestSchema);
}
